const headers = {
  name: "Accounts Payable",
  components: [
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "General Ledger",
        path: "/app/common/reports",
      },
      {
        name: "Trial Balance",
        path: "/app/common/reports/trail-balance",
      },
      {
        name: "Balance Sheet",
        path: "/app/common/reports/balance-sheet",
      },
      {
        name: "Profit & Loss",
        path: "/app/common/reports/profit-loss",
      },
      {
        name: "AR Report",
        path: "/app/common/reports/ar-report",
      },
      {
        name: "AP Report",
        path: "",
      },
      {
        name: "Overall Transaction Report",
        path: "/app/common/reports/overall-transaction",
      },
       {
        name: "Day Book Report",
        path: "/app/common/reports/day-book",
      },
    ],
    total: [
      { value: 0, label: "Total Payable" },
      { value: 0, label: "Overdue Amount" },
      { value: 0, label: "Available Discounts" },
    ],
  },
};

export default headers;
